import {
    STOCK_ALERT_LIST_ATTEMPT,
    STOCK_ALERT_LIST_SUCCESS,
    STOCK_ALERT_LIST_FAILED,
    STOCK_ALERT_NEW_SUCCESS,
    STOCK_ALERT_NEW_FAILED,
    STOCK_ALERT_REMOVE_SUCCESS,
    STOCK_ALERT_REMOVE_FAILED,
} from '../types/stockAlertTypes';
import { LOGOUT } from '../types/sessionTypes';

const INITIAL_STATE = {
    loading: false,
    list: [],
    error: '',
};

function stockAlert(state = INITIAL_STATE, action) {
    switch (action.type) {
        case STOCK_ALERT_LIST_ATTEMPT:
            return { ...state, loading: true };
        case STOCK_ALERT_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: action.data.list,
                error: '',
            };
        case STOCK_ALERT_LIST_FAILED:
            return { ...state, loading: false, error: action.error };
        case STOCK_ALERT_NEW_SUCCESS:
            return {
                ...state,
                list: [action.item, ...state.list.filter((row) => row.id !== action.item.id)],
                error: '',
            };
        case STOCK_ALERT_NEW_FAILED:
            return { ...state, error: action.error };
        case STOCK_ALERT_REMOVE_SUCCESS: {
            const list = state.list.filter((row) => String(row.id) !== String(action.item.id));
            return { ...state, list, error: '' };
        }
        case STOCK_ALERT_REMOVE_FAILED:
            return { ...state, error: action.error };
        case LOGOUT:
            return INITIAL_STATE;
        default:
            return state;
    }
}

export default stockAlert;
